// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InputHint{display:block;margin-top:8px;font-style:italic;color:#777;font-size:13px}\n", ""]);
// Exports
module.exports = exports;
